module.exports = __webpack_public_path__ + "static/media/Home-PinkWaveMobile2.c167da1d.svg";